import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  MdOutlineRemove,
  MdEdit,
  MdOutlineCancel,
  MdCheck,
} from "react-icons/md";

import "./RepeatPopup.css";

function IterationContainer({
  i,
  iterations,
  setIterations,
  workingIteration,
  setWorkingIteration,
  renaming,
  setRenaming,
}) {
  const textRef = useRef();
  const removeButtonRef = useRef();
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  useEffect(() => {
    if (deleteConfirmation) {
      window.addEventListener("click", handleClick);
    } else {
      window.removeEventListener("click", handleClick);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteConfirmation]);

  useEffect(() => {
    if (renaming === i) textRef.current.focus();
  }, [renaming]);

  const handleClick = useCallback((e) => {
    if (
      removeButtonRef.current &&
      !removeButtonRef.current.contains(e.target)
    ) {
      setDeleteConfirmation(false);
    }
  }, []);

  const handleNameChange = (input) => {
    let temp = [...iterations];
    temp[i] = input;
    setIterations(temp);
  };

  const removeIteration = (x) => {
    window.removeEventListener("click", handleClick);
    let temp = [...iterations];
    temp.splice(x, 1);
    setIterations(temp);
  };

  const cancelChanges = () => {
    setWorkingIteration(-1);
    setRenaming(-1);
  };

  const acceptChanges = () => {
    setWorkingIteration(-1);
    setRenaming(-1);
  };

  return (
    <div className="iteration-container">
      <p style={{ marginRight: "0.25em" }}>{i + 1}.</p>
      {renaming === i && (
        <input
          ref={textRef}
          type="text"
          className="iteration-textbox"
          defaultValue={iterations[i]}
        />
      )}
      {renaming !== i && (
        <div
          className="iteration-name-button"
          style={{
            backgroundColor: workingIteration === i ? "#a9d6bc" : "",
            boxShadow:
              workingIteration === i ? "inset 0 1px 2px 0 #00000040" : "",
          }}
          onClick={() => {
            setRenaming(-1);
            setWorkingIteration(i);
          }}
          onDoubleClick={() => {
            setRenaming(i);
          }}
        >
          {iterations[i]}
        </div>
      )}
      {renaming !== i && (
        <div
          className="iteration-button edit"
          onClick={() => {
            setDeleteConfirmation(false);
            setRenaming(i);
          }}
        >
          <MdEdit size={"1em"} style={{ color: "#444444" }} />
        </div>
      )}
      {renaming === i && (
        <>
          <div className="iteration-button cancel" onClick={cancelChanges}>
            <MdOutlineCancel size={"1em"} style={{ color: "#444444" }} />
          </div>
          <div className="iteration-button confirm" onClick={acceptChanges}>
            <MdCheck
              size={"1em"}
              style={{ color: "#444444" }}
              onClick={() => {
                handleNameChange(textRef.current.value);
              }}
            />
          </div>
        </>
      )}
      <div
        ref={removeButtonRef}
        className="iteration-button remove"
        style={{
          backgroundColor: renaming !== i ? "#ed7878" : "#dbc9c9",
          pointerEvents: renaming !== i ? "auto" : "none",
          width: deleteConfirmation ? "4em" : "1.5em",
        }}
        onClick={() => {
          if (!deleteConfirmation) {
            setRenaming(-1);
            setDeleteConfirmation(true);
          }
          if (renaming !== i && deleteConfirmation) {
            removeIteration(i);
            setDeleteConfirmation(false);
          }
        }}
      >
        {!deleteConfirmation && (
          <MdOutlineRemove
            size={"1em"}
            style={{
              color: renaming !== i ? "#6b2525" : "#ac8585",
              pointerEvents: "none",
            }}
          />
        )}
        {deleteConfirmation && (
          <h6 className="delete-confirmation-text">REMOVE</h6>
        )}
      </div>
    </div>
  );
}

export default IterationContainer;
